/* vm-cart.js (L7, DESIGN-SYSTEM-V53 §4.6, §4.11): <vm-cart-add> posts the Cell to /cart/update and fires
   Horizon's CartLinesUpdateEvent (no JS: the form posts to /cart/add); aria-busy on a line while its price
   shimmers; "We couldn't update your cart. Try again." on a failed update; focus moves to the added line. */
import { CartLinesUpdateEvent as Lines, StandardEvents } from '@shopify/events';

const say = (from) => {
  const host = from instanceof Element ? from.closest('cart-items-component') : null;
  for (const el of (host || document).querySelectorAll('.vm-cart__error')) {
    el.textContent = "We couldn't update your cart. Try again.";
    el.hidden = false;
  }
};
const json = (url, init) => fetch(url, { ...init, headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }).then((r) => r.json().then((d) => (r.ok && Array.isArray(d.items) ? d : Promise.reject(d))));

customElements.get('vm-cart-add') ||
  customElements.define(
    'vm-cart-add',
    class extends HTMLElement {
      connectedCallback() {
        this.querySelector('form')?.addEventListener('submit', this.add);
      }
      add = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const button = form.querySelector('button');
        if (button.ariaBusy === 'true') return;
        button.ariaBusy = 'true';
        const id = form.elements.id.value;
        const done = Lines.createPromise();
        this.dispatchEvent(new Lines({ action: 'add', context: 'cart', lines: [{ merchandiseId: id, quantity: 1 }], promise: done.promise }));
        const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId))];
        let cart = null;
        let ok = true;
        try {
          cart = await json(form.dataset.updateUrl, { method: 'POST', body: JSON.stringify({ updates: { [id]: 1 }, sections: sections.join(), sections_url: location.pathname }) });
        } catch (error) {
          ok = false;
          cart = await json(`${form.dataset.cartUrl}.js`).catch(() => null);
        }
        done.resolve({
          cart: cart && Lines.createCartFromAjaxResponse(cart),
          detail: { items: cart?.items, itemCount: cart?.item_count ?? 0, sections: ok ? cart.sections : undefined, source: 'vm-cart-add', didError: !ok },
        });
        button.ariaBusy = null;
        if (!ok) return say(this);
        // The re-render drops the Cell row (and the focused Add with it): put focus on the new line's name.
        const t0 = Date.now();
        const settle = () => {
          if (button.isConnected && Date.now() - t0 < 4000) return setTimeout(settle, 60);
          const a = document.activeElement;
          if (a && a !== document.body) return;
          const link = `.vm-cart-line a.cart-items__title[href*="variant=${id}"]`;
          (document.querySelector(`dialog.vm-cart[open] ${link}`) || document.querySelector(link))?.focus();
        };
        setTimeout(settle, 60);
      };
    }
  );

if (!window.vmCartWatch) {
  window.vmCartWatch = 1;
  new MutationObserver((records) => {
    for (const { target } of records) {
      const line = target.closest?.('.vm-cart-line');
      if (line) line.ariaBusy = target.hasAttribute('shimmer') ? 'true' : null;
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['shimmer'], subtree: true });
  // INVALID = the store's own per-line message, which Horizon already prints under the line.
  document.addEventListener(StandardEvents.cartError, (event) => event.code === 'INVALID' || say(event.target));
}
